import React from "react";

import CallToPhotographersMain from "./images/call-to-photographers.png";
import BlogImageOne from "./images/blogImage1.png";
import BlogImageTwo from "./images/blogImage2.png";
import BlogImageThree from "./images/blogImage3.png";
import CallForPhotosOne from "./images/CallForPhotosOne.png";
import CallForPhotosTwo from "./images/CallForPhotosTwo.png";
import CallForPhotosThree from "./images/CallForPhotosThree.png";
import Photo from "core/ReusableIcons/Photo";
import Eye from "core/ReusableIcons/Eye";
import Receipt from "core/ReusableIcons/Receipt";

import { PRICING, legalPath } from "data/links";

// Metadata
export const metaTitle = "Call To Photographers | Noun Project";
export const twitterTitle = "Call To Photographers";
export const twitterCardContent = "summary_large_image";
export const metaDescription =
    "Contribute to an art-quality stock photo collection that celebrates diversity and supports photographers. Earn above-market royalty rates for direct sales.";
export const socialMediaDescription =
    "Contribute to Noun Project’s curated collection of photos that celebrate diversity and represent a more inclusive world. Earn above-market royalty rates.";
export const previewImgAlt =
    "Photos by Alia Youssef (top left) and by Carina König from Noun Project";

// Section 1: Call to Photographers
export const heroImageMain = CallToPhotographersMain;
export const heroTitle = "Call to Photographers";
const firstParagraph = (
    <>
        Photos have the power to{" "}
        <a
            href="https://blog.thenounproject.com/introducing-noun-project-photos-35d92bc95ab7"
            target="_blank"
        >
            shape, reinforce, and change
        </a>{" "}
        our perceptions. Help us build a more inclusive world.
    </>
);
const secondParagraph =
    "Join our global community of professional photographers.";
export const mainSectionParagraphs = [firstParagraph, secondParagraph];

export const applyNowLinkInfo = [
    {
        text: "Apply Now",
        href:
            "https://docs.google.com/forms/d/e/1FAIpQLSdBkH2rW2wLnVGblkj87THkwVVH5EhDHKotcdaQYnTR2SinwQ/viewform",
        target: "_blank"
    }
];

// Section 2: Blog Previews
export const blogPostsTitle =
    "We are building a collection of professionally curated, art-quality photos that celebrate diversity and support photographers.";

export const blogPostData = [
    {
        title: "“Photography absolutely has the power to change the world.”",
        category: "Avel Shah",
        imgSrc: BlogImageOne,
        url:
            "https://blog.thenounproject.com/photographer-feature-avel-shah-744263538e37",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title:
            "“It can be a great first step in building empathy and understanding.”",
        category: "Alia Youssef",
        imgSrc: BlogImageTwo,
        url:
            "https://blog.thenounproject.com/photographer-feature-alia-youssef-72f35bc66b23",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title:
            "“Photos can help people better understand those who are different and break down cultural barriers.”",
        category: "Denis Kuvaiev",
        imgSrc: BlogImageThree,
        url:
            "https://blog.thenounproject.com/photographer-feature-denis-kuvaiev-e3f6c51ed983",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];

// Section 3: Why contribute to NP
export const sectionThreeTitle = "Why contribute to Noun Project?";
export const sectionThreeSubText =
    "Share your photos with our community of over 7 Million members. In 2020, Noun Project paid $2 Million in royalties to thousands of creators around the world.";
const photoSubText = (
    <>
        We support photographers with revenue from{" "}
        <a href={`${PRICING}#photos`}>royalty-free licenses,</a> while providing
        free limited access to 1MP images with embedded attribution.
    </>
);
export const BulletData = [
    {
        icon: <Eye size="xl" />,
        title: "Professionally Curated",
        text:
            "We put quality over quantity, hand-curating every photo to bring only the most authentic, art-quality, and emotive images into the collection."
    },
    {
        icon: <Photo size="xl" />,
        title: "Thoughtful Licensing",
        text: photoSubText
    },
    {
        icon: <Receipt size="xl" />,
        title: "Excellent Royalties",
        text:
            "Photographers earn above-market royalty rates of 60% from each direct sale of their photo on our platform. We don’t require exclusivity.\n"
    }
];

// Section 4: Call for Photos
export const sectionFourTitle = "Call for Photos";
export const sectionFourData = [
    {
        title: "Dynamic Aging",
        imgSrc: CallForPhotosOne,
        url:
            "https://medium.com/@suzanne_strong/685e89eaca9a?source=friends_link&sk=4dda77f401be929296277e65afd60767",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Outdoors for All",
        imgSrc: CallForPhotosTwo,
        url:
            "https://medium.com/@suzanne_strong/93a9ca3bf189?source=friends_link&sk=66ebc9768266378ff68c7a1b000e7842",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "People Everyday",
        imgSrc: CallForPhotosThree,
        url:
            "https://medium.com/@suzanne_strong/228ea1c9dfc5?source=friends_link&sk=b6710a3404a4da9634b22de0f96231a7",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];

// Section 5: Common Questions
export const sectionFiveTitle = "Common Questions";
const howGetStarted = (
    <>
        Fill out the simple{" "}
        <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdBkH2rW2wLnVGblkj87THkwVVH5EhDHKotcdaQYnTR2SinwQ/viewform"
            target="_blank"
        >
            application form
        </a>{" "}
        where you can share links to your professional work. If your application
        is approved, we’ll get in touch with next steps.
    </>
);
const whatLicensesUse = (
    <>
        We use CC Attribution NonCommercial No-Derivates and Royalty-free
        licenses. We do not allow photos to be used in advertisements, resold,
        or used on products. Please see detailed{" "}
        <a href={`${legalPath}terms-of-use/#photo-licenses`}>photo license</a>{" "}
        info here.
    </>
);
const howPhotographerPaid = (
    <>
        Noun Project pays you royalties of 60% from each direct sale of your
        photo. Payments are made within 10 business days after the end of each
        month to the PayPal address you provide.{" "}
        <a
            href="https://thenounproject.zendesk.com/hc/en-us/articles/200585056-How-do-I-get-paid-"
            target="_blank"
        >
            See payout details
        </a>
        .
    </>
);
export const sectionFiveValues = [
    {
        title: "How do I get started?",
        text: howGetStarted
    },
    {
        title: "How much will I make?",
        text:
            "While we can’t predict how much any one photographer will make, statistically creators with more content on our platform earn higher royalties. In 2020, our top creators earned between $18,000 to $72,000 in passive income."
    },
    {
        title: "What licenses do you use?",
        text: whatLicensesUse
    },
    {
        title: "How do photographers get paid?",
        text: howPhotographerPaid
    },
    {
        title: "Do free downloads affect photo sales?",
        text:
            "The free/paid model has been highly successful for our creators for nearly 10 years, resulting in millions of sales. Downloads of hi-res photos, editing rights, and more are only available for paid photos."
    },
    {
        title: "Do you require model and property releases?",
        text:
            "We require releases if a photograph includes a recognizable individual or property. If a photo has no release but is newsworthy, it may be accepted as Editorial Use Only."
    }
];
